/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name alert
 * @description Date picker to replicate the one found on the bepoz Back Office reports.
 */
angular.module('mercury.directives.alert', [])
  .controller('Controller', ['$scope', function($scope) {
    $scope.message = '';
  }])
  .directive('alert', function() {
    return {
      restrict: 'EA',
      templateUrl: 'directives/alert/alert.tpl.html',
      replace: true,
      link: function(scope, element, attr) {

        scope.message = attr.message;

        element.addClass('alert-' + attr.type);

        element.on('click', function() {
          element.css({
            display: 'none'
          });
        });

      }
    };
  });
